export default __webpack_public_path__ + "static/media/avatar5.5a9b6637.png";